export const CITY = 'modifyData/CITY';
export const USERINFO = 'modifyData/USERINFO';
export const CHANGEINFO = 'modifyData/CHANGEINFO';
export const MODIFY_DATALOADINGTRUE = 'modifyData/MODIFY_DATALOADINGTRUE';
export const MODIFY_DATALOADINGFALSE = 'modifyData/MODIFY_DATALOADINGFALSE'